import { FunctionComponent } from 'react';
import { BoxVariants } from './Box.types';
import BoxDefault from './variants/BoxDefault';
import BoxGradient from './variants/BoxGradient/BoxGradient';
import BoxOutlineGradient from './variants/BoxOutlineGradient/BoxOutlineGradient';

export const BOX_COMPONENTS: Record<BoxVariants, FunctionComponent<object>> = {
  default: BoxDefault,
  gradient: BoxGradient,
  'outline-gradient': BoxOutlineGradient,
};
